import get from 'lodash/fp/get';
import getOr from 'lodash/fp/getOr';
import flow from 'lodash/fp/flow';
import overEvery from 'lodash/fp/overEvery';
import negate from 'lodash/fp/negate';
import filter from 'lodash/fp/filter';
import map from 'lodash/fp/map';
import find from 'lodash/fp/find';
import flatten from 'lodash/fp/flatten';

export const getWaitingListCustomersIsFetching = get('waitingListCustomers.isFetching');
const getWaitingListCustomersUpdatedAt = get('waitingListCustomers.updatedAt');

const ONE_MINUTE_IN_MILLISECONDS = 60000;
const getWaitingListCustomersTimedOut = (state, day) => flow(
  getWaitingListCustomersUpdatedAt,
  find({ day }),
  getOr(0, 'timeStamp'),
  updatedAt => Date.now() - updatedAt > ONE_MINUTE_IN_MILLISECONDS,
)(state, day);

export const shouldFetchWaitingListCustomers = (state, day) => overEvery([
  negate(getWaitingListCustomersIsFetching),
  getWaitingListCustomersTimedOut,
])(state, day);

const getWaitingCustomersItems = (state, day) => flow(
  get('waitingListCustomers.items'),
  filter({ day }),
  map('customers'),
  flatten,
)(state);

const getWaitingCustomersItemsForBarber = (state, barberId, day) => flow(
  getWaitingCustomersItems,
  filter({ barberId }),
)(state, day);

export const getCustomersWaitingForBarber = (state, barberId, day) => flow(
  getWaitingCustomersItemsForBarber,
  get('length'),
)(state, barberId, day);

const mapWaitingListCustomer = map(({ customer, services, barberId }) => ({
  ...customer,
  services,
  barberId,
}));

export const getWaitingListCustomersForBarber = (state, barberId, day) => flow(
  getWaitingCustomersItemsForBarber,
  mapWaitingListCustomer,
)(state, barberId, day);

export const getCustomersWaiting = (state, day) => flow(
  getWaitingCustomersItems,
  get('length'),
)(state, day);

export const getWaitingListCustomersForShop = (state, day) => flow(
  getWaitingCustomersItems,
  mapWaitingListCustomer,
)(state, day);
